import { CurrentDifficulty } from '../../game/config/difficulty'
import { useL10n } from '../hooks/useL10n'
import './PauseOverlay.css'

interface Props {
  isOpen: boolean
  onResume: () => void
  onExit: () => void
  onSettings: () => void
  skin?: string
}

export default function PauseOverlay({ isOpen, onResume, onExit, onSettings, skin }: Props) {
  const { t } = useL10n()
  if (!isOpen) return null

  const isEasyMode = CurrentDifficulty.get() === 'easy'
  const skinKey = skin === 'negro' ? 'raiz' : (skin === 'loiro' ? 'dourado' : (skin === 'moreno' ? 'instrutor' : (skin || 'equilibrado')))
  
  const sig = (() => {
    if (skinKey === 'raiz') return { name: t('moves_guide.cabecada_name'), desc: t('moves_guide.cabecada_desc') }
    if (skinKey === 'dourado') return { name: t('moves_guide.relampago_name'), desc: t('moves_guide.relampago_desc') }
    if (skinKey === 'instrutor') return { name: t('moves_guide.chamada_name'), desc: t('moves_guide.chamada_desc') }
    return { name: t('moves_guide.armada_name'), desc: t('moves_guide.armada_desc') }
  })()

  const characterName = t(`skins.${skinKey}_name`) || 'Lucas Andrade (Equilibrado)'

  const baseMoves = [
    { name: t('controls.martelo'), keys: 'Z', btn: 'A', desc: t('moves_guide.martelo_desc') },
    { name: t('controls.rasteira'), keys: '↓ + Z', btn: '↓ + A', desc: t('moves_guide.rasteira_desc') },
    { name: t('controls.bencao'), keys: 'X', btn: 'B', desc: t('moves_guide.bencao_desc') },
    { name: t('controls.esquiva'), keys: 'C', btn: 'X', desc: t('moves_guide.esquiva_desc') },
    { name: t('controls.au'), keys: '↓ + C', btn: '↓ + X', desc: t('moves_guide.au_desc') },
    { name: t('controls.special'), keys: t('ui.settings') === 'CONFIGURAÇÕES' ? 'Espaço' : 'Space', btn: 'Y', desc: t('moves_guide.meialua_desc') },
    { name: `${sig.name} (${t('ui.settings') === 'CONFIGURAÇÕES' ? 'Assinatura' : 'Signature'})`, keys: '↓ + X', btn: '↓ + B', desc: sig.desc }
  ]

  return (
    <div className="pause-overlay">
      <div className="pause-container">
        <div className="pause-modal">
          <h2 className="pause-title">{t('ui.settings') === 'CONFIGURAÇÕES' ? 'JOGO PAUSADO' : 'GAME PAUSED'}</h2>
          
          <div className="pause-menu">
            <button className="pause-btn pause-btn--primary" onClick={onResume}>
              {t('ui.settings') === 'CONFIGURAÇÕES' ? 'CONTINUAR' : 'CONTINUE'}
            </button>
            
            <button className="pause-btn" onClick={onSettings}>
              {t('ui.settings')}
            </button>
            
            <button className="pause-btn pause-btn--danger" onClick={onExit}>
              {t('ui.settings') === 'CONFIGURAÇÕES' ? 'SAIR DA PARTIDA' : 'EXIT MATCH'}
            </button>
          </div>

          <div className="pause-footer">
            {t('ui.settings') === 'CONFIGURAÇÕES' 
              ? 'Use [ESC] ou [P] para pausar/despausar' 
              : 'Use [ESC] or [P] to pause/unpause'}
          </div>
        </div>

        {isEasyMode && (
          <div className="pause-help-card animate-slide-right">
            <div className="pause-help-card__header">
              <span className="pause-help-card__badge">💡 {t('ui.settings') === 'CONFIGURAÇÕES' ? 'MODO FÁCIL: DICAS DE GOLPES' : 'EASY MODE: MOVE TIPS'}</span>
              <h3 className="pause-help-card__char-name">{characterName.toUpperCase()}</h3>
            </div>
            
            <div className="pause-help-card__scroll-content">
              {baseMoves.map((move, index) => (
                <div key={index} className="pause-help-item">
                  <div className="pause-help-item__top">
                    <span className="pause-help-item__name">{move.name}</span>
                    <div className="pause-help-item__inputs">
                      <span className="pause-help-pill kbd-pill">⌨ {move.keys}</span>
                      <span className="pause-help-pill pad-pill">🎮 {move.btn}</span>
                    </div>
                  </div>
                  <p className="pause-help-item__desc">{move.desc}</p>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
